/// <reference path="../../app.ts" />

interface ICfncReligions extends ng.IDirective {
    
}

interface ICfncReligionsScope extends ng.IScope {
    mode: string;
    ngModel: number;
    selected: any;
    religions: Array<any>;
    religionChanged: (newValue) => void;
}

class CfncReligions implements ICfncReligions {
    static directiveId: string = "cfncReligions";
    restrict: string = "E";
    replace: boolean = true;
    scope: any = {
        mode: "@type", //types: display, select 
        ngModel: "="
    };
 
    templateUrl: string = "/app/directives/cfncReligions/cfncReligions.html";

    constructor() {
    }

    link = (scope: ICfncReligionsScope, element, attrs) => {
        scope.religionChanged = (newValue): void => {
            scope.ngModel = newValue.value;
        };

        scope.religions = this.getReligions();
        
        scope.$watch("ngModel", (newValue, oldValue) => {
            scope.selected = _.find(scope.religions, (r: any) => {
                return r.value == scope.ngModel;
            }) || {
                    name: "",
                    value: null
                };
        });
    }

   
    getReligions = ():Array<any> => {
        return [
            { name: "Select a religion", value: null },
            { name: "African Methodist Episcopal", value: 1 },
            { name: "Agnostic", value: 2 },
            { name: "Anglican", value: 3 },
            { name: "Apostolic Christian", value: 4 },
            { name: "Assemblies of God", value: 5 },
            { name: "Atheist", value: 6 },
            { name: "Baha'I Faith", value: 7 },
            { name: "Baptist", value: 8 },
            { name: "Baptist (Conservative)", value: 9 },
            { name: "Baptist (Other)", value: 10 },
            { name: "Baptist (Southern)", value: 11 },
            { name: "Buddhist", value: 12 },
            { name: "Campus Crusade for Christ", value: 13 },
            { name: "Catholic", value: 14 },
            { name: "Catholic (Greek)", value: 15 },
            { name: "Catholic (Other)", value: 16 },
            { name: "Catholic (Roman)", value: 17 },
            { name: "Christian", value: 18 },
            { name: "Christian (Disciples of Christ)", value: 19 },
            { name: "Christian (Other)", value: 20 },
            { name: "Christian Brethren (Plymouth Brethren)", value: 21 },
            { name: "Christian Reformed", value: 22 },
            { name: "Christian Science", value: 23 },
            { name: "Church of Christ", value: 24 },
            { name: "Church of God", value: 25 },
            { name: "Church of the Nazarene", value: 26 },
            { name: "Congregational", value: 27 },
            { name: "Coptic", value: 28 },
            { name: "Eastern Christian Orthodox", value: 29 },
            { name: "Episcopal", value: 30 },
            { name: "Evangelist", value: 31 },
            { name: "First Christian", value: 32 },
            { name: "Grace Reformed", value: 33 },
            { name: "Great Commission", value: 34 },
            { name: "Hindu", value: 35 },
            { name: "Interdenominational", value: 36 },
            { name: "Intervarsity Christian Fellowship", value: 37 },
            { name: "Jain", value: 38 },
            { name: "Jehovah's Witnesses", value: 39 },
            { name: "Jewish", value: 40 },
            { name: "Jewish (Conservative)", value: 41 },
            { name: "Jewish (Orthodox)", value: 42 },
            { name: "Jewish (Other)", value: 43 },
            { name: "Jewish (Reform)", value: 44 },
            { name: "Latter-day Saint (Mormon)", value: 45 },
            { name: "Lutheran (Missouri Synod)", value: 46 },
            { name: "Lutheran (National Conference)", value: 47 },
            { name: "Lutheran (Unspecified)", value: 48 },
            { name: "Lutheran (Wisconsin)", value: 49 },
            { name: "Mennonite", value: 50 },
            { name: "Methodist", value: 51 },
            { name: "Muslim", value: 52 },
            { name: "Navigators", value: 53 },
            { name: "Non-Christian (Other)", value: 54 },
            { name: "None", value: 55 },
            { name: "Other", value: 56 },
            { name: "Pentecostal", value: 57 },
            { name: "Presbyterian", value: 58 },
            { name: "Presbyterian (Reformed)", value: 59 },
            { name: "Protestant", value: 60 },
            { name: "Protestant (Other)", value: 61 },
            { name: "Reorganized Latter-day Saint", value: 62 },
            { name: "Seventh-Day Adventist", value: 63 },
            { name: "Sikh", value: 64 },
            { name: "Society of Friends", value: 65 },
            { name: "Trinity Church", value: 66 },
            { name: "Unification", value: 67 },
            { name: "Unified Family", value: 68 },
            { name: "Unitarian Universalists", value: 69 },
            { name: "United Church", value: 70 },
            { name: "Wesleyan", value: 71 },
            { name: "World Wide Discipleship", value: 72 }];
    }
}

angular.module("app").directive(CfncReligions.directiveId, [() =>
    new CfncReligions()
]);
